export default "__VITE_ASSET__DwyC45AF__"